// Function use to convert date and add one plus day
export const getDateWithOnePlus = (cartLineMinDate: string) => {
    if (cartLineMinDate === '') {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const converedStringDate = new Date(cartLineMinDate!);
    converedStringDate.setDate(converedStringDate.getDate() + 1);

    // Get year, month, and day part from the date
    const updatedYear = converedStringDate.toLocaleString('default', { year: 'numeric' });
    const updatedMonth = converedStringDate.toLocaleString('default', { month: '2-digit' });
    const updatedDay = converedStringDate.toLocaleString('default', { day: '2-digit' });
    // Generate yyyy-mm-dd date string
    const formatedDate = `${updatedYear}-${updatedMonth}-${updatedDay}`.trim();

    return formatedDate;
};

// Function use to convert date and add one plus day
export const getMinimumDate = (atpOrderShipDateArr: any[]) => {
    if (atpOrderShipDateArr.length) {
        return null;
    }

    const arr: any[] = [];

    atpOrderShipDateArr?.map(e => {
        arr.push({ date: new Date(e.response.ATPDate) });
    });

    // Sort in Decending order (High to Low)
    const sortedDesc = arr.sort((objA, objB) => Number(objB.date) - Number(objA.date));

    const date = sortedDesc && sortedDesc.length && sortedDesc[0]?.date;
    // Create a date object from a date string

    // Get year, month, and day part from the date
    const year = date.toLocaleString('default', { year: 'numeric' });
    const month = date.toLocaleString('default', { month: '2-digit' });
    const day = date.toLocaleString('default', { day: '2-digit' });

    // eslint-disable-next-line react/no-direct-mutation-state
    return `${year}-${month}-${day}`.trim();
};
